export enum EBillingTaskType {
  coinsPurchase = 1,
  subscriptionPurchase = 2,
  cryptoDeposit = 3,
  cryptoWithdraw = 4,
  paypalDeposit = 5,
  paypalWithdraw = 6,
  cardDeposit = 7,
}
